export default {
  id: null,
  hotel_id: null,
  info: {
    name: null,
    duration: {
      stop: null,
      start: null
    },
    signing_date: null,
    signing_agent: null,
    contract_number: null
  },
  options: {
    type: "standard",
    rooms: [],
    total_value: 0,
    installments: [],
    contract_links: [],
    use_percentage: 0,
    total_inventory: 0
  },
  files: []
}